import { ArrayMinSize, IsOptional, ValidateNested } from 'class-validator';
import { Expose, Type } from 'class-transformer';
import { ApiPropertyOptional } from '@nestjs/swagger';

import { JobSpMappingInterface } from '../interfaces/job-sp-mapping.interface';
import { SpBuilderNameCreateDto } from '../../sp/builder-name/dtos/sp-builder-name-create.dto';
import { SpBuilderNameCreatableInterface } from '../../sp/builder-name/interfaces/sp-builder-name-creatable.interface';
import { SpSubdivisionNameCreateDto } from '../../sp/subdivision-name/dtos/sp-subdivision-name-create.dto';
import { SpSubdivisionNameMapableInterface } from '../../sp/subdivision-name/interfaces/sp-subdivision-name-mapable.interface';
import { SpModelNameMapableInterface } from '../../sp/model-name/interfaces/sp-model-name-mapable.interface';
import { SpModelNameCreateDto } from '../../sp/model-name/dtos/sp-model-name-create.dto';
import { SpSubdivisionNameMapableDto } from '../../sp/subdivision-name/dtos/sp-subdivision-name-mapable.dto';
import { SpModelNameMapableDto } from '../../sp/model-name/dtos/sp-model-name-mapable.dto';
import { SpBuilderBoardTypeCreateDto } from '../../sp/builder-board-type/dtos/sp-builder-board-type-create.dto';
import { SpBuilderBoardTypeMapableDto } from '../../sp/builder-board-type/dtos/sp-builder-board-type-mapable.dto';
import { SpBuilderBoardTypeMapableInterface } from '../../sp/builder-board-type/interfaces/sp-builder-board-type-mapable.interface';

export class JobSpMappingDto implements JobSpMappingInterface {
  @ApiPropertyOptional({
    type: () => SpBuilderNameCreateDto,
    title: 'Builder Name Mapping',
    description: 'Optional building name mapping',
  })
  @Expose()
  @ValidateNested()
  @Type(() => SpBuilderNameCreateDto)
  spBuilderName?: SpBuilderNameCreatableInterface;

  @ApiPropertyOptional({
    type: () => SpSubdivisionNameCreateDto,
    title: 'Subdivision Name Mapping',
    description: 'Optional subdivision name mapping',
  })
  @Expose()
  @ValidateNested()
  @Type(() => SpSubdivisionNameMapableDto)
  spSubdivisionName?: SpSubdivisionNameMapableInterface;

  @ApiPropertyOptional({
    type: () => SpModelNameCreateDto,
    title: 'Model Name Mapping',
    description: 'Optional model name mapping',
  })
  @Expose()
  @ValidateNested()
  @Type(() => SpModelNameMapableDto)
  spModelName?: SpModelNameMapableInterface;

  @ApiPropertyOptional({
    type: () => SpBuilderBoardTypeCreateDto,
    title: 'Builder Board Type Mapping',
    description: 'Optional builder board type mapping',
  })
  @Expose()
  @IsOptional()
  @ArrayMinSize(1)
  @ValidateNested()
  @Type(() => SpBuilderBoardTypeMapableDto)
  spBuilderBoardTypes?: SpBuilderBoardTypeMapableInterface[];
}
